// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAnalytics } from 'firebase/analytics'

// TODO: Add SDKs for Firebase products that you want to use

// Your web app's Firebase configuration
// Configuration wird aus Umgebungsvariablen geladen (siehe .env Datei)
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
}

// Validierung: Prüfe ob kritische Umgebungsvariablen gesetzt sind (nur in Entwicklung)
if (process.env.NODE_ENV === 'development' && !firebaseConfig.apiKey) {
  console.warn(
    '⚠️ Firebase API Key fehlt! Bitte erstelle eine .env Datei basierend auf .env.example'
  )
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig)
//Export db
export const db = getFirestore(app)

export const analytics = getAnalytics(app) // Analytics aktivieren
